// extracted by mini-css-extract-plugin
export var banner = "main-banner-module--banner--CiDOO";
export var children = "main-banner-module--children--pynnK";
export var content = "main-banner-module--content--w3ZVM";
export var dark = "main-banner-module--dark--SKcbC";
export var img = "main-banner-module--img--9vHGT";
export var imgBox = "main-banner-module--img-box--Usiy0";
export var ratio = "main-banner-module--ratio--eF2Oj";
export var subtitle = "main-banner-module--subtitle--M-+uC";
export var title = "main-banner-module--title--6evuv";